export default "__VITE_ASSET__C9K6P8Sm__"